<template lang="pug">
  div
    ReloadAppDialog(:showDialog="showDialog")
    b-row.mb-12
      b-col.mb-12
        div
          b-alert(variant="success", dismissible, :show="sendedMailAlert", @dismiss-count-down="countDownChanged")
            | Se enviará un mail junto con el archivo csv
    b-row.mb-2
      b-col(md="1")
        b-btn(variant="primary", @click="exportData", size="sm")
          icon(name="download")
          |  Exportar tabla
      b-col(md="2")
        b-btn(:disabled="sendedMailAlert != 0", variant="success", @click="exportBackup", size="sm")
          icon(name="download")
          |  Descargar todos
    b-row.mb-2
      b-col(md="4")
        span.button-group
          b-btn.btn-space(@click="searchByState('Pendiente decisión - Departamento ERR')", size="sm")
            | Pendientes ERR
          b-btn.btn-space(@click="searchByState('Resuelto')", size="sm")
            | Resueltos
          b-btn.btn-space(@click="searchByState('Rechazado')", size="sm")
            | Rechazados

    b-row.justify-content-md-center
      b-col(md="12")
        ag-grid-vue(style="width: 100%; height: 700px;" class="ag-theme-balham",
        :columnDefs="columnDefs",
        :rowData="rowData",
        :gridOptions="gridOptions")
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import kexaApi from '@/services/apiService';
import constants from '@/constants/Status.constants';
import '@/datasources/datasource';
import { AgGridVue } from 'ag-grid-vue';
import dateService from '@/utils/dateService';

export default {
  name: 'all',
  data() {
    return {
      rowData: null,
      columnDefs: null,
      statuses: { ...constants.STATUSES, ...constants.STATUSES_ECOMMERCE },
      dismissSecs: 5,
      sendedMailAlert: 0,
      gridOptions: {
        floatingFilter: true,
        enableServerSideFilter: true,
        paginationPageSize: 50,
        rowModelType: 'infinite',
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        onRowSelected: this.onRowSelected,
        onSelectionChanged: this.onSelectionChanged,
      },
      showDialog: false,
      intervalId: null,
    };
  },
  components: {
    'ag-grid-vue': AgGridVue,
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: 'ID Reclamo',
        field: 'id',
        cellRenderer(params) {
          if (params.data === undefined) {
            return '';
          }
          return `<a href="/#/${params.data.ecommerce === true ? 'complaints_ecommerce' : 'complaints'}/${params.data.id_string}" target="_blank">${params.data.id}</a>`;
        },
      },
      { headerName: 'Estado', field: 'state' },
      { headerName: 'Booking', field: 'booking' },
      { headerName: 'Tickets', field: 'tickets' },
      { headerName: 'Monto', field: 'amount' },
      { headerName: 'Categoría', field: 'category', suppressSorting: true },
      { headerName: 'Requerimiento', field: 'comment' },
      { headerName: 'Empresa de bus', field: 'bus_operators' },
      { headerName: 'Grupo de empresas', field: 'group', suppressFilter: true },
      { headerName: 'Edad', field: 'age', suppressFilter: true },
      { headerName: 'Fecha ingreso', field: 'created_at', suppressFilter: true },
      { headerName: 'Fecha envío a empresa', field: 'sent_at', suppressFilter: true },
      { headerName: 'Fecha Resuelto', field: 'resolved_at', suppressFilter: true },
      { headerName: 'Correo activado', field: 'reminder', suppressFilter: true },
      { headerName: 'Agente', field: 'agent_name', suppressFilter: true },
    ];
    this.refreshReloaAppStatus();
  },
  mounted() {
    this.fetchComplaints();
  },
  methods: {
    fetchComplaints() {
      const $this = this;
      const dataSource = {
        rowCount: null, // behave as infinite scroll
        getRows(params) {
          kexaApi.all_complaints(params.startRow, params.endRow, params.filterModel)
            .then((data) => {
              const rowsThisPage = $this.parseResponse(data.body.data);
              let lastRow = -1;
              if (data.body.total_rows <= params.endRow) {
                lastRow = data.body.total_rows;
              }
              params.successCallback(rowsThisPage, lastRow);
            });
        },
      };
      this.gridOptions.api.setDatasource(dataSource);
    },
    onRowSelected(event) {
      const values = Object.values(event.node.data);
      const data = values.join(',');
      this.copyText(data);
    },
    onSelectionChanged() {
      const nodes = this.gridOptions.api.getSelectedNodes();
      const values = nodes.map(k => Object.values(k.data).join(','));
      const data = values.join('\n');
      this.copyText(data);
    },
    copyText(text) {
      navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
        if (result.state === 'granted' || result.state === 'prompt') {
          navigator.clipboard.writeText(text).then(() => { }, () => { });
        }
      });
    },
    complaintAge(complaint) {
      return dateService.complaintAge(complaint.created_at);
    },
    parseResponse(data) {
      const processed = data.map((complaint) => {
        const price = complaint.ticket_info && complaint.ticket_info.price;
        const currency = complaint.ticket_info && complaint.ticket_info.sold_currency;
        return {
          id: complaint.number,
          id_string: complaint._id && complaint.$oid,
          state: this.statuses && complaint.aasm_state && this.statuses[complaint.aasm_state] && this.statuses[complaint.aasm_state].description,
          booking: complaint.ticket_info && complaint.ticket_info.booking_number,
          tickets: complaint.ticket_info && complaint.ticket_info.tickets,
          amount: `${price || ''} ${currency || ''}`,
          ecommerce: complaint.ecommerce,
          category: complaint.complaint_category_id && complaint.complaint_category_id.name,
          comment: complaint.comment,
          bus_operators: complaint.ticket_info && complaint.ticket_info.bus_operators,
          group: '-',
          age: this.complaintAge && this.complaintAge(complaint),
          created_at: dateService && dateService.getDate && complaint.created_at ? dateService.getDate(complaint.created_at, 'DD/MM/YYYY HH:mm') : null,
          sent_at: complaint.sent_at === null ? null : dateService && dateService.getDate && dateService.getDate(complaint.sent_at, 'DD/MM/YYYY HH:mm'),
          resolved_at: complaint.approved_at === null ? null : dateService && dateService.getDate && dateService.getDate(complaint.approved_at, 'DD/MM/YYYY HH:mm'),
          reminder: complaint.reminder ? 'Si' : 'No',
          agent_name: complaint.agent_name || '-',
        };
      });
      return processed;
    },
    exportData() {
      this.gridOptions.api.exportDataAsCsv();
    },
    exportBackup() {
      this.sendedMailAlert = this.dismissSecs;
      kexaApi.exportComplaints();
    },
    countDownChanged(dismissCountDown) {
      this.sendedMailAlert = dismissCountDown;
    },
    searchByState(state) {
      const stateFilterComponent = this.gridOptions.api.getFilterInstance('state');
      stateFilterComponent.filterText = state;
      this.gridOptions.api.onFilterChanged();
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>

<style lang="scss">
  .btn-space {
    margin-right: 5px;
  }
  div.ag-root .ag-cell-focus {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
</style>




// WEBPACK FOOTER //
// src/components/complaints/All.vue